import { useI18n } from "../i18n";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, FlaskConical } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const PayPalLabel = () => (
  <><span className="font-black italic">Pay</span><span className="font-black italic -ml-2 text-[#009cde]">Pal</span></>
);

const PayButtons = ({ config, isAdmin, busy, onPay, t }) => (
  <div className="grid gap-3 mt-2">
    {config?.stripe_enabled && (
      <button className="pay-btn pay-card" onClick={() => onPay("stripe")} disabled={!!busy} data-testid="pay-stripe-btn">
        <CreditCard size={18} /> {busy === "stripe" ? t("redirect") : t("payCard")}
      </button>
    )}
    {config?.paypal_enabled && (
      <button className="pay-btn pay-paypal" onClick={() => onPay("paypal")} disabled={!!busy} data-testid="pay-paypal-btn">
        {busy === "paypal" ? t("redirect") : <PayPalLabel />}
      </button>
    )}
    {isAdmin && (
      <button className="pay-btn pay-sim" onClick={() => onPay("sim")} disabled={!!busy} data-testid="pay-simulate-btn">
        <FlaskConical size={16} /> {t("simulate")}
      </button>
    )}
    <p className="font-mono text-[11px] text-subtle mt-1">{t("payNote")}</p>
  </div>
);

const startPayment = async (kind, plan) => {
  const body = { plan_id: plan.id, origin_url: window.location.origin };
  if (kind === "stripe") {
    const r = await api.post("/payments/stripe/checkout", body);
    window.location.href = r.data.checkout_url;
    return null;
  }
  if (kind === "paypal") {
    const r = await api.post("/paypal/checkout", body);
    window.location.href = `${window.location.origin}/api/paypal/go/${r.data.tx_id}`;
    return null;
  }
  const r = await api.post("/payments/simulate", { plan_id: plan.id });
  return r.data;
};

export const PayDialog = ({ plan, onClose }) => {
  const { t } = useI18n();
  const { user, setUser } = useAuth();
  const [config, setConfig] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/payments/config").then((r) => setConfig(r.data)); }, []);

  const go = async (kind) => {
    setBusy(kind);
    try {
      const updated = await startPayment(kind, plan);
      if (!updated) return;
      setUser(updated);
      toast.success(t("simulated"));
      onClose();
    } catch (e) {
      toast.error(t("payError"));
      setBusy(null);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#10121A] border-[#242A38] text-[#F1F5F9] rounded-none" data-testid="pay-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">{t("planName")}</DialogTitle>
          <DialogDescription className="font-mono text-[#8892B0]">{t("planDesc")}</DialogDescription>
        </DialogHeader>
        <PayButtons config={config} isAdmin={user?.is_admin} busy={busy} onPay={go} t={t} />
      </DialogContent>
    </Dialog>
  );
};
